package com.neurobs.js.dom

import com.neurobs.js.dom.ElementFactory._
import com.neurobs.js.dom.DOMViewElement._
import com.neurobs.js.view.Container
import org.scalajs.dom.raw.HTMLElement

class RecordTableView(columns: Seq[RecordTableView.ColumnHeader]) {
	import RecordTableView._

	private val table = ElementFactory.makeTable(columns map { x =>
		if (x.tip.isEmpty) makeText(x.title)
		else ElementFactory.addTooltip(x.title, x.tip)
	})

	def clear(): Unit = {
		while (table.rows.length > 1) {
			table.deleteRow(-1)
		}
	}

	def setContents[T](records: Seq[T], toRow: T => Seq[CellContent]): Unit = {
		clear()
		if (records.isEmpty) table.appendChild(makeSingleColumnTableRow(cell = "None", columns.size))
		else for (i <- records) table.appendChild(makeTableRow(toRow(i).map(toHTML(_))))
	}

	def container: Container = table
}

object RecordTableView {
	case class ColumnHeader (title: String, tip: String = "")

	implicit def toColumnHeader(title: String): ColumnHeader = ColumnHeader(title)

	private def toHTML(c: CellContent): HTMLElement = c match {
		case TextCell(text) => makeText(text)
		case ExternalLinkCell(text, url) => makeExternalLink(text, url)
		case GeneralCell(e) => e
		case c: CommandLinkCell =>
			val temp = makeLink(c.text)
			temp.setHandler(() => c.action())
			temp
	}

	trait CellContent
	case class TextCell(text: String) extends CellContent
	case class ExternalLinkCell(text: String, url: String) extends CellContent
	case class CommandLinkCell(text: String, action: () => Unit) extends CellContent
	case class GeneralCell(element: HTMLElement) extends CellContent

	implicit def toCellContent(text: String): CellContent = TextCell(text)
	implicit def toCellContent(textOpt: Option[String]): CellContent = TextCell(textOpt.getOrElse(""))
	implicit def toCellContent(element: HTMLElement): CellContent = GeneralCell(element)
}
